import { useContext, useReducer } from 'react';
import { useTranslation } from 'react-i18next';

import SortByModal, { useSortFilterOptions } from 'components/Srp/SortByModal/index';
import { colors, screen } from 'components/styles/variables';

import SortByTapEvent from 'lib/Tracking/Srp/SearchFilters/SortByTap';
import useEvents from 'lib/hooks/useEvents';
import { Features } from 'lib/EventSchema';
import { useSortByFilter } from 'lib/hooks/useSrpFilters';

import SrpEventContext from 'contexts/SrpEventContext';
import TopBarDropdownContainer from './TopBarDropdownContainer';
import FiltersModal from '../FiltersModal';
import HeaderIconButton from './HeaderIconButton';

export default function SortByFilterCta({
  totalCount,
  searchVehicles,
}: {
  totalCount: number;
  searchVehicles: () => Promise<void>;
}): JSX.Element {
  const { t } = useTranslation();
  const logger = useEvents();
  const srpEventContext = useContext(SrpEventContext);
  const [shouldShowFiltersModal, toggleFiltersModal] = useReducer(
    (shouldShow) => !shouldShow,
    false
  );

  const label = useLabel();
  return (
    <>
      <div className="sort-by-filter-cta-container-desktop">
        <TopBarDropdownContainer
          title={t('srp.topBar.sortBy')}
          placeHolderCtaText={label}
          filter="sort"
          handleClick={(): Promise<void> =>
            logger.log(
              SortByTapEvent({
                feature: Features.srpHeader,
                sourcePage: srpEventContext.sourcePage,
              })
            )
          }
        >
          <SortByModal />
        </TopBarDropdownContainer>
      </div>
      <div className="sort-by-filter-cta-container-tablet">
        <TopBarDropdownContainer
          isIcon={true}
          filter="sort"
          handleClick={(): Promise<void> =>
            logger.log(
              SortByTapEvent({
                feature: Features.srpHeader,
                sourcePage: srpEventContext.sourcePage,
              })
            )
          }
        >
          <SortByModal />
        </TopBarDropdownContainer>
        <HeaderIconButton icon="filter" onClick={toggleFiltersModal} />
        <FiltersModal
          onClick={toggleFiltersModal}
          isModalOpen={shouldShowFiltersModal}
          totalCount={totalCount}
          searchVehicles={searchVehicles}
        />
      </div>
      <style jsx>{`
        .sort-by-filter-cta-container-desktop {
          min-width: 220px;
          height: 42px;
          border-radius: 8px;
          padding-left: 12px;
          margin-left: 8px;
          cursor: pointer;
          white-space: nowrap;
          display: none;
          line-height: 1px;
        }

        @media (min-width: ${screen.lgMin}) {
          .sort-by-filter-cta-container-desktop {
            display: initial;
          }
        }

        .sort-by-filter-cta-container-desktop:hover {
          background-color: ${colors.G1};
        }

        .sort-by-filter-cta-container-tablet {
          display: flex;
          flex-direction: row;
        }

        @media (min-width: ${screen.lgMin}) {
          .sort-by-filter-cta-container-tablet {
            display: none;
          }
        }
      `}</style>
    </>
  );
}

function useLabel(): string {
  const options = useSortFilterOptions();
  const { value } = useSortByFilter();
  const { t } = useTranslation();
  const option = options.find((opt) => opt.value === value);
  return option?.label || t('srp.sortBy.bestMatch');
}
